import { styled } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const BaseAccordionExpandIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  height: "14px",
  width: "14px",
  color: theme.palette.text.primary,
}));
